import { render, staticRenderFns } from "./TargetSkillsSection.vue?vue&type=template&id=19bb2cff&scoped=true&"
import script from "./TargetSkillsSection.vue?vue&type=script&lang=js&"
export * from "./TargetSkillsSection.vue?vue&type=script&lang=js&"
import style0 from "./TargetSkillsSection.vue?vue&type=style&index=0&id=19bb2cff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb2cff",
  null
  
)

export default component.exports